// extracted by mini-css-extract-plugin
module.exports = {"compactView":"CompactView_compactView__1t-tH","isDisabledCompactView":"CompactView_isDisabledCompactView__3Rm_O"};